'use client';

import { useTranslations } from 'next-intl';
import { EmailPasswordPreBuiltUI } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui';
import { ThirdPartyPreBuiltUI } from 'supertokens-auth-react/recipe/thirdparty/prebuiltui';
import { AuthPage } from 'supertokens-auth-react/ui';

import { Modal } from '@/components/molecules';
import { tenantMap } from '@/lib/auth/constants';
import { useDialog } from '@/lib/hooks/auth/useDialog';
import { cn } from '@/lib/utils/tailwind';

export const AuthModal = ({ name }: { name: string }) => {
  const t = useTranslations();
  const { currentDialog, closeDialog } = useDialog();
  const open = currentDialog === 'auth';

  return (
    <Modal.Root
      isOpen={open}
      onOpenChange={open => {
        if (!open) closeDialog();
      }}
      className={cn(
        'min-w-max overflow-auto max-h-full p-0 bg-(--color-surface-default)',
        {
          'rounded-(--radius-xl)': name !== tenantMap.staatsoperTV,
        },
      )}
    >
      <Modal.Header className="border-0 p-2 justify-end ">
        <Modal.Title className="sr-only">{t('AUTH_MODAL_TITLE')}</Modal.Title>
        <Modal.Description className="sr-only">
          Please sign in or create an account to continue.
        </Modal.Description>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body className="p-0!">
        <AuthPage
          preBuiltUIList={[EmailPasswordPreBuiltUI, ThirdPartyPreBuiltUI]}
        />
      </Modal.Body>
    </Modal.Root>
  );
};
